import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, graphqlOperation } from 'aws-amplify';
import moment from 'moment';

import { getLmShareSession } from '../../graphql/queries';

import { Club, MeasuringSystem, Session, SessionExtra, Target } from './SessionModel';
import { generateClubGroup, generateTargetGroup } from './helper/GenerateClubGroup';
import { ShowNormalized } from './helper/NormalizedValues';
import { getElevation, getTemparature } from './helper/UnitConversions';

export const getSession = createAsyncThunk(
  'session/getSession',
  async (shareUrl: string): Promise<Session | unknown> => {
    try {
      const sessionData: any = await API.graphql(graphqlOperation(getLmShareSession, { shareUrl }));
      if (
        sessionData &&
        sessionData.data &&
        sessionData.data.getLmShareSession &&
        sessionData.data.getLmShareSession.session
      ) {
        const rawSession = sessionData.data.getLmShareSession.session;
        const mappedSession = { ...rawSession, location: getLocation(rawSession.location) };
        let showNormalized = ShowNormalized(mappedSession);
        let drillTargets = rawSession.drillTargets;
        let clubs: Club[] = generateClubGroup(
          rawSession.shots,
          showNormalized,
          MeasuringSystem.imperial,
          [],
          mappedSession.location,
        );
        let targets: Target[] = generateTargetGroup(
          rawSession.shots,
          showNormalized,
          MeasuringSystem.imperial,
          [],
          drillTargets,
          mappedSession.location,
        );
        let response: Session = {
          ...rawSession,
          name: getSessionName(rawSession),
          location: mappedSession.location,
          temperatureConverted: getTemparature(rawSession.normalizedTemperature, MeasuringSystem.imperial),
          elevation: getElevation(rawSession.normalizedElevation, MeasuringSystem.imperial),
          durationString: getDuration(rawSession),
          isNormalized: showNormalized,
          clubs,
          targets,
        };
        return response;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

const getDuration = (session: SessionExtra) => {
  var seconds = session.duration ? session.duration : session.endTimestamp - session.startTimestamp;
  var duration = moment.duration(seconds * 1000);
  if (duration.hours() > 0) {
    return moment.utc(duration.asMilliseconds()).format('h:mm:ss');
  } else {
    return moment.utc(duration.asMilliseconds()).format('mm:ss');
  }
};

const getLocation = (location: String) => {
  switch (location) {
    case 'OutdoorRange':
      return 'Outdoor';
    case 'IndoorRange':
      return 'Indoor';
    default:
      return location;
  }
};

const getTimeOfDay = (date: Date) => {
  var hour = date.getHours();
  var dayOfWeek = moment(date).format('dddd');
  var timeOfDay = '--';
  switch (true) {
    case hour >= 6 && hour < 12:
      timeOfDay = 'Morning';
      break;
    case hour === 12:
      timeOfDay = 'Noon';
      break;
    case hour >= 13 && hour < 17:
      timeOfDay = 'Afternoon';
      break;
    case hour >= 17 && hour < 22:
      timeOfDay = 'Evening';
      break;
    default:
      timeOfDay = 'Night';
  }
  return `${dayOfWeek} ${timeOfDay}`;
};

const getSessionName = (session: SessionExtra) => {
  console.log('getSessionName ', session);
  if (session.name && session.name.length > 0) {
    return session.name;
  }

  if (session.startTimestamp > 0) {
    var startDate = new Date(session.startTimestamp * 1000);
    return getTimeOfDay(startDate);
  }

  switch (session.location) {
    case 'OutdoorRange':
      return 'Outdoor Session';
    case 'Screen':
      return 'Screen Session';
    case 'Net':
      return 'Net Session';
    default:
      return '--';
  }
};
